/* @flow */

import type { CanvasElement } from './types.js.flow';

export function showElements(els: $ReadOnlyArray<CanvasElement>) {
  for (let i = 0; i < els.length; i++) {
    els[i].draw();
  }
}
